import { FunctionComponent, ReactNode } from 'react'

import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { Button, Grid, Modal, SvgIcon, Text } from '@/tbui'

export interface StyledVenueInfoAreaProps {
  open: boolean
}

const StyledClosedVenueModal = styled(Modal)<StyledVenueInfoAreaProps>`
  background: ${(props): string => props.theme.palette.WHITE};
  box-shadow: ${(props): string => props.theme.shape.SHADOW};
  place-self: center;
  z-index: 9999;
  overflow: ${(props): string => (props.open ? 'auto' : 'hidden')};
  border-radius: ${(props): string => props.theme.shape.RADIUS};
  transition: 0.25s ease;
  bottom: ${({ open }): string => (open ? '0vh' : '-100vh')};
  padding: 27px 24px 26px 19px;
`

const StyledButton = styled(Button)`
  color: ${(props): string => props.theme.palette.WHITE};
  margin-top: 50px;
`

const ClosedVenueModal: FunctionComponent<{
  open: boolean
  venueReopensAt: string | null
  onClose: () => void
}> = ({ open, venueReopensAt, onClose }) => {
  const { t } = useTranslation()

  const renderClosedMessage = (): ReactNode => {
    if (venueReopensAt != null) {
      return (
        <Grid gap="50px" container>
          <Grid justify="center">
            <SvgIcon name="alert" fontSize="68px" color="ERROR" />
          </Grid>
          <Text type="H1" align="center">
            {t('restaurant_closed')}
          </Text>
          <Text type="H3" align="center" bold={false}>
            {t('modal.closed_venue.reopen_message', {
              value: venueReopensAt,
            })}
          </Text>
        </Grid>
      )
    }
    return (
      <Grid gap="50px" container>
        <Grid justify="center">
          <SvgIcon name="alert" fontSize="68px" color="ERROR" />
        </Grid>
        <Text type="H4" fontSize="30px" align="center">
          <strong>{t('restaurant_closed')}</strong>
        </Text>
      </Grid>
    )
  }

  return (
    <StyledClosedVenueModal data-test="closed-venue" open={open} onClose={onClose}>
      {renderClosedMessage()}
      <StyledButton onClick={onClose}>{t('modal.closed_venue.confirmation')}</StyledButton>
    </StyledClosedVenueModal>
  )
}

export default ClosedVenueModal
